import { PayloadAction } from '@reduxjs/toolkit';

import { initialState } from 'store/slice/accountModalSlice';
import { IAccountModalState } from 'store/types/accountModalTypes';

export const closeAccountModal = (state: IAccountModalState) => {
  state.modalContext = null;
};
export const openCreateAccountModal = (state: IAccountModalState) => {
  state.modalContext = 'createAccount';
};

export const openForgotPasswordModal = (state: IAccountModalState) => {
  state.modalContext = 'forgotPassword';
};

export const openLoginModal = (state: IAccountModalState, action: PayloadAction<string>) => {
  state.modalContext = 'logIn';
  state.hideToggleLink = action?.payload === 'hideToggleLink';
};

export const openResetPasswordModal = (state: IAccountModalState) => {
  state.modalContext = 'resetPassword';
};

export const setOtpModal = (
  state: IAccountModalState,
  action: PayloadAction<{ show: boolean; message?: string }>,
) => {
  state.showOtpModal = action?.payload?.show;
  state.otpModalText = action?.payload?.message;
};

export const setTwoFactorAuthModal = (
  state: IAccountModalState,
  action: PayloadAction<{ show: boolean; message?: string }>,
) => {
  state.showTwoFactorAuthModal = action?.payload?.show;
  state.twoFactorAuthModalText = action?.payload?.message;
};

export const setDidntReceiveCodeModal = (
  state: IAccountModalState,
  action: PayloadAction<{ show: boolean }>,
) => {
  state.showDidntReceiveCodeModal = action?.payload?.show;
};

export const setRedirect = (state: IAccountModalState, action: PayloadAction<string>) => {
  state.redirect = action?.payload;
};

export const setButtonText = (state: IAccountModalState, action: PayloadAction<string>) => {
  state.buttonText = action?.payload;
};

export const setGuestEmail = (state: IAccountModalState, action: PayloadAction<string>) => {
  state.guestEmail = action?.payload;
};

export const setSubtitle = (state: IAccountModalState, action: PayloadAction<string>) => {
  state.subtitle = action?.payload;
};

export const setTitle = (state: IAccountModalState, action: PayloadAction<string>) => {
  state.title = action?.payload;
};

export const setPasswordResetToken = (state: IAccountModalState, action: PayloadAction<string>) => {
  state.passwordResetToken = action?.payload;
};

export const triggerCaptcha = (state: IAccountModalState, action: PayloadAction<string>) => {
  state.showCaptcha = action.payload === 'on';
};

export const setDarkTheme = (state: IAccountModalState, action: PayloadAction<boolean>) => {
  state.darkTheme = action?.payload;
};

export const resetModalTextAndRedirect = (state: IAccountModalState) => {
  state.buttonText = initialState.buttonText;
  state.redirect = initialState.redirect;
  state.title = initialState.title;
  state.subtitle = initialState.subtitle;
};

export const triggerLoginBeforeAction = (
  state: IAccountModalState,
  action: PayloadAction<{ buttonText?: string; title: string; darkTheme: boolean }>,
) => {
  const { buttonText, title, darkTheme } = action?.payload;
  state.modalContext = 'logIn';
  state.buttonText = buttonText;
  state.title = title;
  state.darkTheme = darkTheme;
};

export const triggerLoginBeforeCheckout = (
  state: IAccountModalState,
  action: PayloadAction<{ buttonText: string; title: string; redirect: string }>,
) => {
  const { redirect, buttonText, title } = action?.payload;
  state.modalContext = 'logIn';
  state.redirect = redirect;
  state.buttonText = buttonText;
  state.title = title;
};
